import { BootstrapIcon, getBootstrapIconUrl } from '@/components/webcomponents/Global/icons'
import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavHeaderUtilityStyles } from './NavHeaderUtility.styles'

const bellIcon = getBootstrapIconUrl(BootstrapIcon.Bell)

const t = document.createElement('template')
t.innerHTML = `
<wa-button size="small" appearance="plain" class="utility-icon-button">
  <wa-icon 
    src="${bellIcon}" 
    class="header-icon" 
    label="Notifications"
    aria-label="Notifications"
    aria-hidden="false"
    focusable="true"
  ></wa-icon>
</wa-button>`

class NavHeaderUtilityBell extends HTMLElement {
  constructor() {
    super()
    tryLoadDependencies(document, [WebAwesomeComponent.Icon, WebAwesomeComponent.Button])
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderUtilityStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUtilityBell connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-utility-bell')) {
  customElements.define('ts-navheader-utility-bell', NavHeaderUtilityBell)
}
export { NavHeaderUtilityBell }
